import { createDarkTheme, createLightTheme, type BrandVariants } from '@fluentui/react-components';

// ---------------------------------------------------------------------------
// Agrovid Brand Theme — FluentUI v9
// ---------------------------------------------------------------------------
// Paleta de marca:
//   Primary:  #1B7A32  (Deep Agricultural Green)
//   Accent:   #E8A020  (Harvest Gold)
//   Bg:       #F0F5EC  (Morning Mist)
//   Dark:     #1C2528  (Rich Soil)
//
// Generado con la herramienta de tema de FluentUI:
// https://react.fluentui.dev/?path=/docs/theme-designer--docs
// ---------------------------------------------------------------------------

// 16-step brand ramp from #1B7A32
const agrovidBrand: BrandVariants = {
  10:  '#031A09',
  20:  '#072F11',
  30:  '#0B4419',
  40:  '#0E5921',
  50:  '#126E2A',
  60:  '#1B7A32',   // ← PRIMARY
  70:  '#218C3A',
  80:  '#2DA050',
  90:  '#3EB568',
  100: '#5DC880',
  110: '#7DD898',
  120: '#9DE6B0',
  130: '#BCF0C7',
  140: '#D6F7DF',
  150: '#EAFBEE',
  160: '#F5FDF7',
};

export const agrovidLightTheme = {
  ...createLightTheme(agrovidBrand),

  // ── Customise specific tokens ───────────────────────────────────────────
  // Background layers
  colorNeutralBackground1:   '#FFFFFF',
  colorNeutralBackground2:   '#F0F5EC',   // Morning Mist
  colorNeutralBackground3:   '#E7EFE3',
  colorNeutralBackground4:   '#DCE8D8',
  colorNeutralBackground5:   '#D2E2CD',
  colorNeutralBackground6:   '#C8DBC2',

  // Page background (used in AppShell content area)
  colorNeutralBackgroundStatic: '#F0F5EC',

  // Harvest Gold accent — used in charts, KPI highlights
  colorPaletteGoldBorderActive: '#E8A020',

  // Sidebar dark tones
  colorNeutralBackground3Hover: '#DCECD8',
};

export const agrovidDarkTheme = createDarkTheme(agrovidBrand);

// Semantic aliases — use these constants in components instead of raw tokens
// so a rebrand only requires updating this file.
export const brandTokens = {
  green:       '#1B7A32',
  greenLight:  '#3EB568',
  gold:        '#E8A020',
  goldLight:   '#F5C76C',
  soil:        '#1C2528',
  mist:        '#F0F5EC',
  danger:      '#C0392B',
  warning:     '#E8A020',
  info:        '#0073C6',
} as const;
